import { render, staticRenderFns } from "./reviewed.vue?vue&type=template&id=216bd5bb&scoped=true&"
import script from "./reviewed.vue?vue&type=script&lang=js&"
export * from "./reviewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216bd5bb",
  null
  
)

export default component.exports